import { render, staticRenderFns } from "./ChooseBrandAdItem.vue?vue&type=template&id=4d72882d&scoped=true"
import script from "./ChooseBrandAdItem.vue?vue&type=script&lang=js"
export * from "./ChooseBrandAdItem.vue?vue&type=script&lang=js"
import style0 from "./ChooseBrandAdItem.vue?vue&type=style&index=0&id=4d72882d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d72882d",
  null
  
)

export default component.exports